import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'

// El campo videoId puede venir cargado como ID suelto o como URL completa
// (youtu.be/ID, watch?v=ID, embed/ID), asi que normalizamos antes de armar el embed
const YOUTUBE_ID = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|shorts\/|watch\?(?:.*&)?v=))([\w-]{11})/

const getVideoUrl = ({ videoId, mediaVideo }) => {
  if (videoId) {
    const id = videoId.match(YOUTUBE_ID)?.[1] || videoId.trim()
    return `https://www.youtube.com/embed/${id}?rel=0`
  }
  return mediaVideo?.url || null
}

const Video = ({ videoComponent }) => {
    const url = videoComponent && getVideoUrl(videoComponent)

    return (
        <div className="embed-responsive embed-responsive-16by9 mb-5 container">
          {url && (
            <ReactPlayer
              className="embed-responsive-item"
              url={url}
              controls={true}
              width="100%"
              height="100%"
            />
          )}
        </div>
      )
}

export default Video

Video.propTypes = {
    videoComponent: PropTypes.object.isRequired
}
